import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY, TESTING_TOKEN_OVERRIDE_COOKIE_KEY } from '../../../constants';
import { getCookie } from '../get-cookie';
import { overrideConsentTokenForLiveTesting } from '../override-with-testing-cookies';
import { setConsentTokenCookie, setRequiredConsentCookies, setShouldShowBannerCookie } from '../set-required-consent-cookies';
import { getValidConsentData } from './utils';
export var getConsentToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var fallbackConsentToken, consentData, consentToken, consentTimestamp, potentiallyOverriddenConsentToken, testingConsentOverride, hasTestingConsents;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          fallbackConsentToken = getCookie(ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY);
          _context.next = 3;
          return getValidConsentData(fallbackConsentToken);
        case 3:
          consentData = _context.sent;
          if (!consentData) {
            _context.next = 15;
            break;
          }
          consentToken = consentData.consentToken, consentTimestamp = consentData.consentTimestamp;
          /*** TESTING OVERRIDES ***/
          potentiallyOverriddenConsentToken = overrideConsentTokenForLiveTesting(consentToken);
          testingConsentOverride = getCookie(TESTING_TOKEN_OVERRIDE_COOKIE_KEY);
          hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
          if (!hasTestingConsents) {
            _context.next = 13;
            break;
          }
          // If testing, set the cookies accordingly so we can test with any overridden token data.
          setShouldShowBannerCookie(potentiallyOverriddenConsentToken);
          setConsentTokenCookie(potentiallyOverriddenConsentToken);

          // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
          // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
          // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
          return _context.abrupt("return", potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken);
        case 13:
          // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
          setRequiredConsentCookies(potentiallyOverriddenConsentToken, consentTimestamp);
          return _context.abrupt("return", consentToken);
        case 15:
          return _context.abrupt("return", undefined);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getConsentToken() {
    return _ref.apply(this, arguments);
  };
}();